import { render } from "./HeaderGenView.vue?vue&type=template&id=05750428"
import script from "./HeaderGenView.vue?vue&type=script&lang=js"
export * from "./HeaderGenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__